import { render, staticRenderFns } from "./contact-1.vue?vue&type=template&id=df40dc88&scoped=true&"
import script from "./contact-1.vue?vue&type=script&lang=js&"
export * from "./contact-1.vue?vue&type=script&lang=js&"
import style0 from "./contact-1.vue?vue&type=style&index=0&id=df40dc88&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df40dc88",
  null
  
)

export default component.exports